import { createSelector } from 'reselect';
import {
    get, has,
} from 'lodash';
/**
 * Base Selectors
 */
const getAuth = (state) => get(state, 'app.auth', {});
const getAuthUser = (state) => get(state, 'app.database.authUser', {});
const getEntityId = (state, id) => id;
const getEntities = (state) => get(state, 'app.database.travelAgencies', {});
const getMembers = (state) => get(state, 'app.database.members', {});
/**
 * Selector Builders
 */
export const buildTravelAgencySelector = () => createSelector([
    getEntityId,
    getEntities,
], (entityId, entities) =>
{
    if (has(entities, entityId))
    {
        const travelAgency = entities[entityId];

        return {
            ...travelAgency,
        };
    }

    return {};
});

export const buildAuthTravelAgencySelector = () => createSelector([
    getAuth,
    getAuthUser,
], (authState, authUsers) =>
{
    if (has(authUsers, authState?.user?.id))
    {
        const { member } = authState.user;

        return {
            ...member.travelAgency,
        };
    }

    return {};
});
